import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { ItemDataBuilder } from './item-data.builder';
import { ItemDataService } from './item-data.service';
import { EffectsModule } from '@ngrx/effects';
import { ItemDataEffects } from './item-data.effects';
import { FEATURE_NAME, reducer } from './item-data.reducer';
import { StoreModule } from '@ngrx/store';
import { ItemDataStore } from './item-data.store';
import { ItemDataDispatcher } from './item-data.dispatcher';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    EffectsModule.forFeature([ItemDataEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
})
export class ItemDataModule {
  static forRoot(): ModuleWithProviders<ItemDataModule> {
    return {
      ngModule: ItemDataModule,
      providers: [
        ItemDataDispatcher,
        ItemDataService,
        ItemDataBuilder,
        ItemDataStore,
      ],
    };
  }
}
